(function () {
    let deliveryNode = document.getElementById("delivery-time");
    function addBusinessDays(numDays) {
        var date = new Date();
        var count = 0;
        while (count < numDays) {
            date.setDate(date.getDate() + 1);
            if (date.getDay() !== 0 && date.getDay() !== 6) {
                count++;
            }
        }
        return date;
    }

    function formatDate(date) {
        var options = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }

    if (deliveryNode) {
        const isMobile = screen.availWidth < 769;
        const fontSize = isMobile?'font-size: 12px;':'';
        let html = `
        <div style="margin-top: 10px;">
            <div class="delivery-time-container" style="${fontSize}">
            <div>Delivery Date: <span>${formatDate(addBusinessDays(deliveryNode.getAttribute('starttime')))} - ${formatDate(addBusinessDays(deliveryNode.getAttribute('endtime')))}</span></div>
            </div>
        </div>
        `
        deliveryNode.innerHTML = html;
    }

}())